import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Transaction } from '@fry/payments/lib';
import { TracksOperationProgress } from '@fry/components/common';

/**
 * Instructions for off-line payment methods
 *
 * This components presents the information how to pay for the non-card
 * payment methods.
 *
 * User can Cancel or Confirm they made the payment similarily as in case
 * of Wise(TransferWise) workflow.
 *
 * This actions is quite symbolic as the off-line verification of the payment
 * needs to occur.
 */
@Component({
    selector: 'eas-payments-instructions',
    templateUrl: './transaction.instructions.component.html',
    standalone: false
})
export class TransactionInstructionsComponent implements TracksOperationProgress {

    @Input() isOperationInProgress = false;
    @Input() transaction!: Transaction;

    @Output() action = new EventEmitter<void>();
    @Output() cancel = new EventEmitter<void>();

    constructor() { }

    onPaid() {
        this.action.emit();
    }

    onLater() {
        this.cancel.emit();
    }

    onCancel() {
        this.cancel.emit();
    }
}
